<template>
  <div>
    <generic-table
      ref="datatable"
      :title="$t('receipts')"
      :columns="columns"
      :column_search="true"
      resource_url="/receipt/datatables"
      :page_length="25"
    >
      <template v-slot:buttons>
        <button class="button is-secondary is-rounded" @click="create">
          <span class="icon"><i class="fa fa-plus"></i></span>
          <span>{{ $t("add") }}</span>
        </button>
      </template>
    </generic-table>
  </div>

  <receipt-modal ref="receipt_modal" @success="refresh" />
</template>

<script>
// import GenericTable from "../../../../app/src/components/generic_table/GenericTable.vue";
import GenericTable from "@/components/generic_table/GenericTable.vue";
import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  del,
  success_message,
  error_message,
  put,
  format_date,
  format_currency,
} from "@/utils";
import ReceiptModal from "./receipt_modal/Index.vue";

export default {
  name: "ReceiptsDatatable",
  components: { GenericTable, ReceiptModal },
  data() {
    let v = this;
    return {
      columns: [
        {
          title: v.$t("date"),
          name: "date",
          searchable: false,
          data: (row) => {
            return format_date(row.date);
          },
        },
        {
          title: v.$t("received from"),
          name: "received_from",
          searchable: true,
          data: (row) => {
            return row.received_from || "";
          },
        },
        {
          title: v.$t("amount"),
          name: "amount",
          searchable: true,
          data: (row) => {
            return format_currency(row.amount);
          },
        },
        {
          title: v.$t("email"),
          name: "email",
          searchable: true,
          data: (row) => {
            return row.email || "";
          },
        },
        {
          title: v.$t("receipt number"),
          name: "receipt_number",
          searchable: true,
          data: (row) => {
            return row.receipt_number || "";
          },
        },
        // {
        //   title: v.$t("data"),
        //   name: "data",
        //   searchable: true,
        //   data: (row) => {
        //     return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
        //     // return row.name || "";
        //   },
        // },
        {
          title: v.$t("options"),
          searchable: false,
          data: (row) => {
            return generate_datatables_buttons([
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("edit"),
                icon: "fa fa-edit",
                icon_class: "is-small",
                click: function (e) {
                  // console.log("edit order", e.detail.uuid);
                  v.$refs.receipt_modal.edit_modal(e.detail.uuid);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("send receipt"),
                icon: "fa fa-envelope",
                icon_class: "is-small has-text-primary",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  confirm_deletion_dialog(
                    v.$t("are you sure to send receipt over email?"),
                    v,
                    () => {
                      put("/receipt/send", { uuid: uuid })
                        .then(() => {
                          success_message(v.$t("receipt sent"));
                        })
                        .catch((error) => {
                          error_message(error);
                        });
                    }
                  );
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("delete"),
                icon: "fa fa-trash",
                icon_class: "is-small has-text-danger",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  confirm_deletion_dialog(
                    v.$t("are you sure to delete receipt?"),
                    v,
                    () => {
                      del("/receipt", { uuid: uuid })
                        .then(() => {
                          v.refresh();
                        })
                        .catch((error) => {
                          error_message(error);
                        });
                    }
                  );
                },
              },
            ]);
          },
        },
      ],
    };
  },
  methods: {
    create() {
      let v = this;
      v.$refs.receipt_modal.show_modal();
    },
    refresh() {
      let v = this;
      v.$refs.datatable.refresh();
    },
  },
  mounted() {
    this.refresh();
  },
};
</script>

<style></style>
